import { render, staticRenderFns } from "./TrafficsByInmo.vue?vue&type=template&id=d1998168&scoped=true"
import script from "./TrafficsByInmo.vue?vue&type=script&lang=js"
export * from "./TrafficsByInmo.vue?vue&type=script&lang=js"
import style0 from "./TrafficsByInmo.vue?vue&type=style&index=0&id=d1998168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1998168",
  null
  
)

export default component.exports